import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./theme.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router";
import { GemeindeProvider } from "./context/GemeindeContext";
import "./i18n/config";
import ErrorBoundary from "./errors/ErrorBoundary";
import { initColorScheme } from "./theme/colorScheme";

// Light or dark before the first paint (GOD-61).
initColorScheme();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        {/* A render error shows a note instead of a white page (GOD-59). */}
        <ErrorBoundary>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <GemeindeProvider>
                    <App />
                </GemeindeProvider>
            </BrowserRouter>
        </ErrorBoundary>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(logger.warn))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
